import { withStyles } from '@material-ui/core';
import TextareaAutosize from './TextareaAutosize';
import styles from './TextareaAutosize.styles';

export default withStyles(styles)(TextareaAutosize);
